<template>
    <div class="earth-stage">
        <div class="clouds">
            <transition-group name="body-anim">
                <div 
                    v-for="cloud in clouds" 
                    :key="cloud.key" 
                    :class="cloud.type" 
                    class="cloud" 
                    :style="{ 'right': `${cloud.right}%`, 'top': `${cloud.top}%`, 'filter': `blur(${getRandomInt(3, 15)}px)`, 'opacity': `0.${getRandomInt(4, 8)}`, 'animation-duration': `${getRandomInt(12, 20)}s`, 'height': `${getRandomInt(8, 20)}`, 'width': `${getRandomInt(8, 20)}` }"
                />
            </transition-group>
        </div>
        <div class="earth">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 2000 2000" style="enable-background:new 0 0 2000 2000;" xml:space="preserve">
                <circle class="st0" cx="1000.5" cy="975.5" r="924.5"/>
                <g>
                    <path class="st1" d="M1895.7,888.3c-0.3-3.5-3.2-7.8-6.2-9.8c-14.5-9.3-16.1-12.2-10.6-28.4c1.8-5.3,5.1-10.2,6.8-15.5
                        c1.6-4.8,3.5-10.2,2.7-14.9c-7.8-51.6-19.5-102.2-36.2-151.8c-28.8-85.3-69.9-164.2-122.9-236.9c-38.4-52.6-81.3-101.4-131.5-142.9
                        c-38.1-31.6-79.5-59.3-119.3-88.8c-5.4-4-8.9-2.8-13.7,1.4c-17.1,15.3-27,34-26.2,57c0.5,16-5.2,28.9-14.8,40.9
                        c-17.7,22.1-34.9,44.7-53.1,66.4c-8,9.6-10.7,18.5-4.5,29.9c2.5,4.5,4.5,10.1,4.4,15.1c-0.3,16.3,13.1,18.7,23.4,23.7
                        c8.8,4.3,14.3-3.2,20-8.4c1.6-1.4,2.9-3.2,4.7-4.2c4.1-2.3,9.3-6.8,12.3-5.7c3.3,1.2,5.4,7.5,6.7,12c2.5,8.5,3.1,17.5,6.1,25.8
                        c2.7,7.5,8,14.2,17.7,11.2c6.6-2,12.7-5.4,19.6-8.4c-0.7-1.8-1.3-3.4-2-5c-6.6-16.4-5.4-19.7,9.2-30.1c2.7-1.9,5.2-5.2,6.3-8.3
                        c8.7-26.1,7.1-35.4-14.7-44c-2.7-1.1-5.3-5.7-5.5-8.8c-0.1-2.2,3.6-5.5,6.3-6.8c9.9-4.9,15.8-12.8,13.8-23.8
                        c-4.6-25.8,10.2-40.7,29.2-52.8c5.4-3.4,13-3.5,19.5-5.1c-0.3,6.5,0.3,13.1-1,19.3c-4,19.1-8.9,37.9-12.9,56.9
                        c-1.6,7.7-0.8,15.3,6.2,21.3c5.2,4.5,9.8,10,13.9,15.6c5,7,10.3,8.7,16.7,2.6c5.3-5.1,9.9-11.1,15.2-16.3c4-3.9,8.6-7.3,12.9-10.9
                        c3.7,5,7.4,9.9,10.9,15c0.9,1.4,1.2,3.3,1.6,5c2.1,8.7-0.2,13-10.1,15.5c-10.5,2.7-20.2,9.2-29.8,14.9c-2,1.2-3.6,6.4-2.8,8.7
                        c7.5,20.9,7.6,21-14.8,22.3c-0.7,0-1.4,0.1-2.1,0.2c-18.3,1.9-23.5,9.5-18.7,27.2c0.5,1.7,1,3.4,1.6,5.1c4.4,14.2,3.6,16.8-11,20
                        c-26.6,5.9-53.5,11-80.3,15.7c-8.2,1.4-17.2,1.6-25.3,0c-16.8-3.3-20.5-3.1-32,16.4c-2.8,4.8-5.1,10.4-6,15.8
                        c-3.6,23.3-19.4,36.9-37.6,48.8c-13.3,8.7-26.3,18-39.5,26.9c-7.4,5-7,10.8-0.5,15.3c8.7,6,18.4,10.5,27.3,16.2
                        c4.2,2.7,9.4,6.2,10.9,10.4c3.1,8.8,4,18.4,5.9,28.1c-4.4,0.7-7.1,1.3-9.9,1.6c-20.4,2.2-40.9,4.5-61.4,6.3
                        c-5.7,0.5-7.9,2.6-8.6,8.2c-2.1,15.8-7.2,31.7-6.2,47.3c0.7,11.3,9.1,22.2,14.6,33c0.6,1.1,4.6,0.8,7,0.7
                        c13.8-0.4,27.6-0.9,41.4-1.6c3-0.2,7-0.7,8.7-2.6c10.1-11.7,27.2-19.6,23-39.8c-0.5-2.2,0.6-4.9,1.3-7.3
                        c11.9-39.1,48.4-67,89.6-70.9c3.3-0.3,8.6,1.5,9.9,4c8.7,16.6,24.3,25.5,38.6,35.8c17.7,12.7,17.7,12.3,14.1,33.9
                        c-0.5,3.1,2.4,7.7,5.1,10.1c1.2,1.1,8-0.9,8.4-2.4c2-8.2,8.7-8.5,14.8-10c11.2-2.8,13.6-7.5,7.8-17.3c-2.6-4.4-6.1-9.2-10.5-11.7
                        c-21.8-12.6-37.3-31.5-51.8-51.2c-5-6.8-12.6-16-3.9-23.6c8.6-7.4,16.3,1.2,22.9,7c18.7,16.3,36.6,33.5,56.1,48.8
                        c14.7,11.5,17.3,26.8,15.2,42.6c-1.2,8.9,0.7,14,6.6,19.2c2.4,2.1,5.3,4.1,6.7,6.8c5.6,11.4,13.7,10.2,23,5.6
                        c1.9-0.9,3.9-1.8,5.9-2.4c10-2.6,9.8-8.1,5.2-15.6c-5.2-8.4-10-17.1-14.7-25.8c-4.1-7.5-0.3-11.1,6.9-10.8
                        c8.1,0.3,16.2,1.5,24.1,3.2c2.3,0.5,5.7,4.1,5.7,6.4c0.5,19.3,0.3,38.7,0.3,55.4c-9.7,5.3-18,9-25.3,14.2c-6.3,4.4-5.2,10,1.9,12.8
                        c7.2,2.9,14.7,5.6,22.3,6.8c3,0.5,8.5-2.6,9.8-5.5c3.3-7.3,4.7-15.5,7.4-23.1c1-2.8,3.7-6.9,5.9-7.1c25.3-2.6,50.7-4.7,77.7-7
                        c1.2,13.4,2.8,26,3.2,38.6c0.1,3.7-2.3,8.7-5.2,11c-7.5,5.7-9.1,12.2-5.6,20.5c1.5,3.5,3.2,7,5.1,11.2c-2.3,0.9-3.2,1.6-4.2,1.6
                        c-29.7,1.7-59.5,3.6-89.2,4.5c-3.9,0.1-10.1-4.1-11.6-7.7c-3.6-8.8-9.2-13.2-18.3-13.3c-6.7-0.1-13.5-0.1-20.2,0.4
                        c-6.5,0.5-10.9,2.9-8.2,11c3.7,10.8-1.3,18.7-9.7,24.8c-8,5.7-16.7,4.6-23.7-1.3c-7.2-6-15-12.8-18.7-21
                        c-5.7-12.4-15-19.6-26.9-19.1c-22.4,1.1-31.2-11.2-35.7-30c-0.2-0.7-0.6-1.3-0.7-2c-1.1-5.9-4.7-7.9-10.6-7.6
                        c-27.6,1.4-55.3,2.3-82.9,3.8c-3.4,0.2-6.8,2.7-10,4.5c-9.1,5.1-17.5,12-27.2,15.3c-13,4.4-27.1,5.2-40.4,8.9
                        c-19.3,5.4-36.4,26.7-35.7,43.1c0.6,12.8,0.8,25.6,2.3,38.2c0.9,8-1.6,11.6-8.9,15.2c-32.2,15.9-57.8,41.4-62.7,76
                        c-5.5,39.2-3.3,80.1,0.6,119.7c4.1,41.7,30.8,73.4,56.5,105.1c18.3,22.5,38.4,27.1,64.3,16.3c29.4-12.2,59.2-23.5,86.8-34.4
                        c16.1,5.7,31,11.7,46.4,16.4c29.3,8.9,41.6,28,36.3,57.9c-1.2,6.6-2.1,13.3-2.4,20.1c-0.7,17.1,3.7,31.9,18.2,43.1
                        c4.8,3.7,8.4,10.7,9.8,16.8c3.7,16.6,6.6,33.4,8.6,50.2c3.3,27.2,2.6,54.4-14.2,77.6c-9.8,13.5-14.6,28.1-12.6,43.8
                        c4.3,34,9.8,67.9,15.8,101.7c2.7,15.2,7.7,29.9,11.8,45.3c2.8-1.1,4.2-1.4,5.3-2.2c11.2-8.2,22.5-16.1,33.3-24.7
                        c87.5-69,160.1-151.2,217.9-246.5c4.9-8.1,7.8-16,7.3-25.9c-2.4-46.3,9.9-88.4,46.8-117.9c18.8-15,27.6-32.8,33.3-54.1
                        c0.2-0.7,0.6-1.3,0.7-2c6.4-25.3,12.8-50.7,19.6-77.4c-13.2,0-24.4-0.4-35.7,0.2c-6.9,0.4-9.9-2.4-12.4-8.5
                        c-10.4-25.2-20.8-50.4-32.2-75.2c-18.6-40.2-36.9-80.5-63.6-116.4c-5.9-7.9-10.8-16.7-15.2-25.5c-2.7-5.5-5.7-12.7,1.8-17
                        c6.7-3.8,13.5-2.7,19.3,3.2c26.5,26.6,52.6,53.4,50.3,95.2c0,0.3,0.1,0.7,0.1,1.1c1.1,11.2,6.5,18.7,17,23.6
                        c4.6,2.2,8.8,7.7,10.7,12.7c4.7,12.5,6.3,26.3,12.1,38.2c15.8,32.8,15.5,33.7,49.6,16.1c3.7-1.9,7.5-6.9,8-10.9
                        C1897.7,998.9,1899.7,943.6,1895.7,888.3z M1778.6,675.3c-18.1,6.5-36.2,15-54.5-0.2c-2.9-2.4-7-3.4-10.6-4.8
                        c-12.7-4.9-17.6-2.8-20.8,10.5c-2.1,8.7-5.3,11-14,7.5c-4.9-2-11-1.2-16.6-1.3c-15.9-0.3-20.7-7.6-13.7-21.8
                        c2.7-5.4,6.1-10.4,9-15.6c3.5-6.4,5.9-12.2,0.6-19.6c-4.5-6.2-0.7-12.1,7.5-11.2c9,1,18,3.7,26.6,6.8c9.8,3.5,17.6,4.7,22.4-7.4
                        c1.2-3.1,6.7-6.8,9.7-6.4c3.6,0.5,7.4,4.6,9.8,8.1c2.3,3.4,3.2,7.8,4.4,11.9c4.2,13.9,10.6,24.9,26.5,28.6
                        c5.9,1.4,10.8,7.3,16.1,11.2C1780.2,672.9,1779.4,674.1,1778.6,675.3z"/>
                    <path class="st1" d="M979.9,1367.8c-9.2-6.3-19.6-12.2-30.3-15c-25.9-6.9-52.3-12.4-78.7-17.6c-14.8-2.9-29.9-4.2-46-6.4
                        c1.9-5.1,3.3-9.3,5.1-13.4c7.2-16.3,5.9-24.7-6.5-37.4c-15-15.3-34-22.3-54.5-26.9c-10.7-2.4-21.6-4.8-31.4-9.4
                        c-20.7-9.7-30.5-18.7-24.6-43.5c-11.1,1.4-21.5,2.1-31.7,4c-21.3,3.9-41.5,5.4-57.6-13.6c-6.1-7.2-14-5.2-21.1-0.1
                        c-15.8,11.4-28.9,25.4-37.4,42.9c-13.4,27.6-15.4,23-30.1,1.5c-10.8-15.8-23.2-24-43-17c-10.6,3.7-15.5,0.2-16.9-10.9
                        c-1.3-10.5-1.4-21.2-1.6-31.8c-0.3-17.2-5.2-23.5-22.2-26.9c-6.9-1.4-13.8-2.2-22.1-3.5c3.1-11,6.3-20.9,8.6-31.1
                        c3.7-16.9-4.3-24.4-21.3-20.3c-18.8,4.6-31.5,17.2-41.2,33c-9.4,15.2-22.8,18.8-36.9,7.7c-3.8-3-5.9-9.8-6.5-15.1
                        c-1.1-9.4-0.1-19-0.8-28.4c-1.2-16.6-4.5-33.1-4.4-49.6c0.1-19.3,10.7-34.3,29.3-38.7c45.7-10.7,88.9-7.8,123.5,29.8
                        c3,3.3,8.6,7.5,11.7,6.6c3.4-1,6.7-7.2,7.3-11.4c2.2-15.4,4.3-31,4.3-46.5c0.1-29.7,12.7-53.3,35.7-70.2c10-7.4,11-13.5,7.9-23.6
                        c-3.3-10.8-6-21.8-8.3-32.9c-1-4.8,0.1-8.8,6.9-9.2c31.6-1.5,52.8-21.3,69.8-44.7c10.5-14.5,15.8-32.8,22.8-48.1
                        c6,2.5,12.9,8.1,18.5,7.1c25.8-4.7,47.6-17.7,65.9-36.4c1.9-2,3.6-6.2,2.7-8.3c-0.8-1.9-5.2-3.1-8.1-3.1c-7.8,0-15.7,1.6-23.3,0.8
                        c-4.1-0.5-11-4.4-11.2-7.2c-1-14.1-9.4-23.2-18.2-32.7c-9-9.8-7.9-14.9,5.2-16.8c20.3-2.9,40.8-4.4,61.3-5.4
                        c15.2-0.8,20.3,3.3,24,18.3c1.8,7.1,5.7,10.6,12.2,11.3c6.3,0.7,12.8,1,19,0.2c13.1-1.7,15.9-6.9,10-18.9
                        c-8.3-16.9-20.6-30.1-39.4-37.1c4.2-6.6,8.2-12.4,11.6-18.5c4.3-7.9,5.9-16.4,0.4-24.2c-19.8-27.9-39.8-55.8-60.2-83.3
                        c-6-8.1-8.8-7.3-13.2,1.9c-4,8.3-9.1,17.5-18.9,15.8c-6.7-1.2-15.5-7.7-17.9-13.9c-11-29.1-31.6-32.3-58.3-25.9
                        c-15.6,3.8-22.1,6.9-23.1,22.8c-1.4,22.9-1.1,46-0.3,68.9c0.7,18.9-2,26.1-19,33.6c-8.3,3.7-11.9,9.2-12.3,17.9
                        c-0.6,11-0.8,22-2.8,32.8c-1.3,6.7-5.5,12.9-8.4,19.3c-6.2-4.2-13.7-7.3-18.2-12.8c-10.8-13.3-13-29.7-12.4-46.2
                        c0.3-8.3-3.2-12.6-10.4-14.9c-4-1.3-8.2-2.4-12.3-3.5c-13.7-3.5-27.6-6.7-41.2-10.6c-8.2-2.4-15.2-7.2-15.3-16.8
                        c-0.4-25.3,5.1-50,24.1-67c14.5-12.9,25.6-27,34.5-43.7c6.3-11.9,15.7-17.9,29.6-19c21.6-1.7,30.2-10,33-31.7
                        c0.9-6.9-0.4-16.4-4.7-21.2c-5.8-6.4-14.6-2.1-21.4,2.3c-10.7,6.9-22.1,8.9-34.6,6.5c-19.1-3.7-35,4.1-46.3,18
                        c-12.9,15.9-28.3,22.9-48,21.8c-10.4-0.6-16.9,3.8-23.2,11.9c-4.4,5.7-11.4,11.6-18.1,12.9c-26.2,4.9-52.7,6.8-79-0.3
                        c-14.9-4-18.5-2.5-27.2,10.6c-30,45.7-56.2,93.4-77.8,143.8c-50.1,116.9-73.4,238.7-70,365.7c0.8,30.2,2.1,31.5,32.3,27
                        c7.8-1.2,11.3,1.2,13.1,8.1c3.8,14.7,6.9,29.7,11.6,44.2c3.8,12,8.8,23.8,14.6,35c1.6,3.1,8.7,5.8,12.3,4.9c3.8-0.9,8.1-6,9.1-10.1
                        c1.2-4.7-0.3-10.5-1.8-15.4c-2.6-8.4-7.2-16.4-8.9-24.9c-1.1-5.4,0-15,3.2-16.5c5.4-2.6,14.3-2.5,19.5,0.4
                        c5.9,3.4,11,10.5,13.3,17.1c6.9,19.3,12.5,39,18.3,58.7c4.8,16.3,8,33.1,13.9,48.9c6.8,18.4,21.5,26.5,41.2,24.8
                        c17-1.5,33.9-3.2,50.8-4.4c7-0.5,14.3-1,21.1,0.4c13.8,2.9,27.3,6.9,40.8,10.8c6.1,1.8,12,4.3,17.7,7.2
                        c19.4,9.8,29.8,27.7,40.6,45.3c4.8,7.9,10.4,15.3,15.9,23.3c13.6-13.3,13.6-13.3,31.2-10.1c3.5,0.6,7,1.2,10.4,2.2
                        c12.6,3.4,16.7,9.1,17.2,22c1,25.1-9.3,45.9-23.3,65.8c-14.6,20.9-13.9,35.2,1.6,55.3c13,16.9,25.8,33.9,39.7,49.9
                        c25.5,29.2,51.8,57.6,87.5,74.9c11.3,5.5,19.4,13.8,22.2,25.6c5.5,23.8,12.7,47.6,14.2,71.7c3.2,50.2,3.4,100.6,4.2,150.9
                        c0.1,8.2,2.3,12,10.1,14.2c27.2,7.9,54.3,16.1,81.4,24.5c6.9,2.1,10.4-0.2,11.1-6.8c1.1-9.5,1.6-19.1,2.5-28.6
                        c0.8-8,3.1-13.2,13.4-11.4c11,1.9,21.7-6.8,27.2-18.4c4.8-10.2-2.8-13.4-8.2-18.9c-3.3-3.3-4.2-8.9-6.2-13.5
                        c4.7-0.7,9.5-2.5,13.9-1.7c8,1.4,15.7,4.4,23.5,6.8c16.9,5.1,20.9,1.9,19.6-15.4c-0.5-6-2-12.2-1.1-18c0.8-5.1,3.1-11.9,6.9-14.3
                        c12-7.3,13.9-17.5,13.1-30.1c-1.2-18.3-1.1-19.1,17-24.9c30.2-9.7,56.3-23.4,64.9-57.3c1.1-4.4,3.8-8.6,4.4-13.1
                        c2.1-15.6,6.1-31.6,4.6-47c-0.9-9.6-0.6-16.1,6-22.6c3.3-3.2,6.5-6.6,9.4-10.1C1017.5,1431.4,1012.3,1389.9,979.9,1367.8z"/>
                    <path class="st1" d="M664.8,185.1c1.9,3.9,9.5,9.1,12.1,8c8.5-3.6,19.8-5.2,21.5-17.6c0.9-6.6,4.9-9.3,11.7-9.5
                        c11.3-0.4,22.7-1.4,33.9-2.9c6.4-0.8,9.3,1.7,12.5,6.9c5.6,9.2,11.5,18.8,19.3,26c7.1,6.5,10.6,12.7,8.8,22.1
                        c-1.6,8-3.3,16-4.1,24.1c-1,10.4,2,12.7,12.1,10.6c3.5-0.7,7-2.1,10.4-1.8c3.5,0.3,6.8,2.3,10.1,3.6c-2,3.4-3.4,7.6-6.3,9.9
                        c-3.5,2.8-8.6,3.5-12.3,6c-3.9,2.6-10.1,6.7-9.8,9.5c0.6,4.8,4.7,10,8.8,13.1c4.5,3.4,10.7,4.6,17.7,7.4
                        c-4.1,4.3-7.5,7.7-10.8,11.3c-23.7,25.6-26.7,53.6-8.9,82.7c15.4,25.2,38,42.9,62.4,58.2c11.1,7,24.2,5.6,32.4-3.2
                        c6.2-6.6,12.2-14.4,15.1-22.7c5.7-15.9,10-32.5,13.4-49.1c6.1-29.5,5.5-30,34.9-35.5c8.1-1.5,11.9-5.3,15.4-12.3
                        c5-9.9,9.6-22.9,18.2-27.8c28.1-15.8,52.7-40.8,89.3-37.2c9.1,0.9,14.9-9.7,14.9-21.1c0.1-10.8-7.5-10.5-14.5-10.9
                        c-12.4-0.7-24.8-1-37.2-1.4c-10.4-0.3-10.3-8.6-10.8-15.3c-0.5-6-0.9-12.9,9.1-13.3c10.9-0.4,21.8-2.9,32.7-3.4
                        c14-0.6,17.3-2.3,21-15.7c6.9-25.1,6.1-50.4,2.4-75.9c-1.1-7.5-3.9-9.8-11.8-9c-11.9,1.3-16.2-4.3-13.6-16.2
                        c1.1-5,2.6-9.9,4.1-15.4c-3.4-0.4-5.5-0.8-7.5-1c-86.9-6.3-172.9,0.2-257.9,18.6c-51.3,11.1-101.6,26.2-150,46.6
                        c-3.3,1.4-8.1,6.8-7.4,8.6C651.7,155.3,657.7,170.5,664.8,185.1z"/>
                    <path class="st1" d="M581.9,256.4c-8,4.3-16,6-25.5,4.1c-5.5-1.1-13.8,0.2-17.6,3.8c-15.5,15-29.9,31.1-44.3,47.1
                        c-1.9,2.1-2.2,9.1-1.7,9.2c10.7,3.5,11.3,13.1,12.4,21c14.3-2,27.3-4.7,40.4-5.5c10.6-0.7,18.5-3.5,22.5-14
                        c3.5-9,10.7-12,19.7-10.4c9.1,1.6,15.7,6.4,17.5,16.1c0.8,4.5,0.8,9.2,1.6,13.7c0.9,4.9,1.4,10.3,9.3,7.5c1.9-0.7,7,1.9,7.2,3.5
                        c1.4,8.8,2.3,17.9,2.2,26.8c0,1.9-5.6,5.4-8.4,5.1c-12.4-1-20.1,4.9-25.5,15.2c-3.6,6.9-7.6,13.7-10.6,20.8
                        c-2.2,5.3-3.1,11.1-4.6,16.7c5.6-0.9,11.5-1.1,16.8-2.8c13.4-4.4,23.4-1,30.6,11.4c1.6,2.8,2.9,5.7,4.3,8.5
                        c6.8,13.7,10.1,13.9,19,0.9c4-5.9,7.3-12.3,11.9-17.6c13.4-15.2,24-31.4,22-53c-0.1-1.6,0.9-3.2,1.3-4.7c1.2-0.1,2-0.4,2.6-0.2
                        c1.3,0.5,2.6,1.1,3.7,1.8c10.7,6.5,17.3,5.9,24.3-2.2c7.7-8.8,8.7-22.7,0.9-30c-13.8-13-21.7-28.3-24.3-47
                        c-1.8-12.7-10.3-17.9-23.1-16c-4.2,0.6-8.2,2.1-12.2,3.5c-11,4-13.4,2.7-15.4-9.2c-1.2-7-1.9-14.1-3.5-20.9
                        c-4.7-20.4-12.2-24-31-15.1C596.7,248.1,589.4,252.4,581.9,256.4z"/>
                    <path class="st1" d="M482.4,277.8c3.3,1.1,6.9,1.7,10.4,1.7c8.7,0,14.8-4.3,17.7-12.6c1.3-3.7,2-7.5,2.8-11.3
                        c1.8-9.2,7.3-13.3,16.6-12.5c7.4,0.6,14.8,1.4,22.2,1.5c13.1,0.1,21.4-5.4,24-18c2.7-13.1,9.9-22.3,20.5-29.7
                        c4.9-3.4,9.5-7.4,13.7-11.7c11-11.2,12.4-22.8,4.2-36.7c-3.3,1.4-6.3,2.5-9,4c-36.4,20.4-72.9,40.6-109.1,61.4
                        c-10.7,6.2-22.7,11.9-23.5,27.2c-0.1,2.3-1.9,4.6-3.3,6.6C457,266.5,457.7,269.8,482.4,277.8z"/>
                    <path class="st1" d="M1169.9,298c-3.5-4.5-8.9-5.2-10.3,2.9c-1.3,7.6-6.5,10.9-13.4,11.1c-10.9,0.4-21.9,0.1-32.8,0.1
                        c0-0.5,0-1.1-0.1-1.6c-12.7,0.7-25.4,1.1-38,2.4c-7,0.7-11.3,5.1-12.2,12.6c-1,7.8-2.9,15.5-3.6,23.3c-0.2,2.7,1.2,6.5,3.2,8.4
                        c4.4,4,9.4,7.4,14.5,10.4c12.5,7.3,25,14.7,38.1,21c3.6,1.7,9.5,1.3,13.2-0.5c4.5-2.3,7.7-7.1,11.4-10.8
                        c14-14.4,28.2-28.7,41.8-43.4c2.5-2.7,4.8-8.5,3.6-11.1C1181,314,1175.9,305.6,1169.9,298z"/>
                    <path class="st1" d="M1254.4,466.4c11.2,3.2,17.8,10.1,19.9,21.1c1.8,9.3,3.5,18.9,3.4,28.3c-0.1,18.8-1.5,37.5-2.1,56.3
                        c-0.1,3.9,1,7.8,1.5,11.5c12.1-5.6,22.5-13.4,33.8-14.9c20.4-2.6,26.5-16.1,31.8-32.1c2.6-8-0.3-12.8-6.2-18.3
                        c-7.8-7.3-15.1-15.7-20.5-24.9c-11.9-20-22.2-40.9-33.6-61.2c-5.5-9.7-9.7-10.1-18.3-2.5c-5.3,4.7-10.8,9.2-15.6,14.4
                        C1237.8,455.7,1239.3,462.1,1254.4,466.4z"/>
                    <path class="st1" d="M367.5,403.9c1.1-2.2,1.7-5.1,3.4-6.5c2.8-2.3,6.2-4,9.6-5.1c5.6-2,15.2-2.1,16.2-5.2
                        c1.7-5.3-1.5-12.5-3.6-18.5c-3.7-10.6-8.1-20.9-12.3-31.3c-3-7.3-6.2-14.5-10.7-24.9c-28.4,30.9-54.6,59.5-81.9,89.3
                        c8.7,7,15.4,13.3,23,18.2C334.6,435,355.5,428.9,367.5,403.9z"/>
                    <path class="st1" d="M414,337.3c12.9,2.6,22.4,9.1,29.2,20.7c3.7,6.2,9.9,7.7,16.3,2.4c6.8-5.6,13.7-11,20.4-16.8
                        c2.3-2,4-4.7,6.1-7.2c-1.7-2.3-2.7-5-4.2-5.5c-13.8-3.9-18.8-14.5-24-26.7c-2.3-5.5-11.9-9-18.9-11c-7-2-8.8,4.3-10.5,10.2
                        c-0.9,3.1-4.4,5.3-6.8,8c-4,4.5-8.2,8.8-11.9,13.5C405.1,330.8,406.2,335.7,414,337.3z"/>
                    <path class="st1" d="M1238.6,563.3c0.6,0.3,1.2,0.4,0.8,0.3c9.9-8.7,19.5-16.9,28.8-25.5c2.1-1.9,4.2-5.7,3.7-8.1
                        c-3.1-16.1-6.9-32.1-10.8-49.6c-13.3,9.1-25.3,16.8-36.7,25.4c-2.1,1.6-3.1,6.7-2.4,9.7C1226.3,531.8,1217.8,552.7,1238.6,563.3z"
                        />
                </g>
            </svg>
        </div>
        <div class="earth-glow" />
    </div>
</template>

<script>
export default {
    name: 'Earth',
    data() {
        return {
            clouds: null,
        }
    },
    mounted() {
        this.generateClouds();
    },
    methods: {
        generateClouds() {
            let clouds = [];
            let cloudCount = this.getRandomInt(40, 60);
            let cloudClasses = ['cloud1', 'cloud2', 'cloud3', 'cloud4'];

            for(var i=0; i < cloudCount; i++){
                clouds.push({
                    type: cloudClasses[Math.floor(Math.random() * cloudClasses.length)],
                    key: (Math.random() + 1).toString(36).substring(7),
                    right: this.getRandomInt(10, -20),
                    top: this.getRandomInt(0, 40),
                })
            }

            this.clouds = clouds;
        },
        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../styles/palette';

$earthDim: 88vw;

.earth-stage {
	.st0{fill:#5191FF;}
	.st1{fill:#8BC23F;}
    position: relative;
    z-index: 0;
}

@keyframes breathe {
    from { filter: blur(10px); opacity: 0.2; }
    to { filter: blur(40px); opacity: 0.6; }
}

$earthDist: -24rem;

.earth-glow {
    position: absolute;
    margin: auto;
    left: 0; right: 0;
    top: $earthDist;
    z-index: 1;
    height: $earthDim;
    width: $earthDim;
    background-color: $yellow;
    border-radius: 50%;
    filter: blur(20px);
    animation: breathe 6s infinite;
    animation-fill-mode: both;
    animation-direction: alternate;
    opacity: 0.6;
;}

.earth {
    position: absolute;
    margin: auto;
    left: 0; right: 0;
    top: $earthDist;
    z-index: 2;
    height: $earthDim;
    width: 100vw;
}

.modal-body-anim-enter,
.modal-body-anim-leave-to {
    opacity: 0;
}

.modal-body-anim-enter-active,
.modal-body-anim-leave-active {
    transition: opacity .5s ease;
}

// Cloud enter/exit animations
@keyframes cloudEnter {
    from {
        transform: translateX(200%) scale(0.3);
        opacity: 0;
    }
    to {
        transform: translateX(0) scale(1);
        opacity: 1;
    }
}

@keyframes cloudExit {
    from {
        transform: translateX(0) scale(1);
        opacity: 1;
    }
    to {
        transform: translateX(-300%) scale(0.5);
        opacity: 0;
        filter: blur(30px);
    }
}

.body-anim-enter-active {
    animation: cloudEnter 1.2s ease-out forwards;
}

.body-anim-leave-active {
    animation: cloudExit 0.8s ease-in forwards;
}

//CLOUDS
@keyframes floaton {
    0% {
        transform: translateX(120%) translateZ(0) scale(0.5);
        opacity: 0;
    }
    8% {
        transform: translateX(90%) translateZ(0) scale(0.8);
        opacity: 0.6;
    }
    15% {
        transform: translateX(70%) translateZ(0) scale(1);
        opacity: 1;
    }
    85% {
        transform: translateX(-40%) translateZ(0) scale(1);
        opacity: 1;
    }
    92% {
        transform: translateX(-70%) translateZ(0) scale(0.7);
        opacity: 0.4;
    }
    100% {
        transform: translateX(-120%) translateZ(0) scale(0.3);
        opacity: 0;
    }
}

.clouds {
    width: 70%;
    margin: 0 auto;
    height: 120rem;
    position: absolute;
    top: -40rem; left: 0; bottom: 0; right: 0;
}

.cloud {
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    animation-timing-function: linear;
    animation-name: floaton;
}

.cloud {
	background-color: white;
	border-radius: 100px;
	box-shadow: 0 8px 5px rgba(0, 0, 0, 0.1);
	position: relative;
}

.cloud:after, .cloud:before {
    background: white;
	content: '';
	position: absolute;
	z-index: -1;
}

.cloud:after {
	border-radius: 100px;
	height: 20px;
	left: 50px;
	top: -50px;
	width: 20px;
}

.cloud:before {
	border-radius: 200px;
	width: 15px;
	height: 15px;
	right: 20px;
	top: -50px;
}

.cloud1 {
    transform: scale(0.75);
}

.cloud2 {
    transform: scale(0.75) rotate(180deg);
    background-color: $yellow;
}

.cloud2:after, .cloud2:before {
    background-color: $yellow;
}

.cloud3 {
    background-color: pink;
}

.cloud3:after, .cloud2:before {
    background-color: pink;
}

.cloud4 {
    transform: scale(0.5) rotate(220deg);
}
</style>
